import React, { FC } from "react";
import { useErrorBoundary } from "react-error-boundary";

import { Wallets } from "./Wallets";
import { useGetWalletsQuery } from "../../store/services/wallets";

export const WalletsPage: FC = () => {
  const { isError, error } = useGetWalletsQuery();
  const { showBoundary } = useErrorBoundary();

  if (isError) {
    showBoundary(error);
  }

  return (
    <div>
      <Wallets />
    </div>
  );
};
